import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetFilterComponent } from './widget-filter/web-widget-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaterialModuleWeb } from '../material/material.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharedModule } from 'shared-library';
import { TableModule } from '../vl-table/table.module';

@NgModule({
  declarations: [WidgetFilterComponent],
  imports: [
    CommonModule,
    MaterialModuleWeb,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    HighchartsChartModule,
    TableModule,
    SharedModule
  ],
  exports:[
    WidgetFilterComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class WebWidgetCoreModule { }
